import LeagueLists from './LeagueTablePage';

export default LeagueLists;
